import { ToolSEO } from '../types';

export const toolSEOData: Record<string, ToolSEO> = {
  // Image Tools
  'webp-to-jpg': {
    title: 'Convert WEBP to JPG - Free Online WEBP to JPEG Converter',
    description: 'Convert WEBP images to JPG format instantly. Free online WEBP to JPEG converter. No uploads, no registration required.',
    keywords: 'webp to jpg, webp to jpeg, webp converter, convert webp to jpg, webp to jpg online, free webp converter, webp to jpg converter',
    searchTerms: ['webp to jpg', 'webp to jpeg converter', 'convert webp to jpg', 'webp to jpg online']
  },
  'png-to-jpg': {
    title: 'Convert PNG to JPG - Free Online PNG to JPEG Converter',
    description: 'Convert PNG images to JPG format instantly. Free online PNG to JPEG converter. No uploads, no registration required.',
    keywords: 'png to jpg, png to jpeg, png converter, convert png to jpg, png to jpg online, free png converter, png to jpg converter',
    searchTerms: ['png to jpg', 'png to jpeg converter', 'convert png to jpg', 'png to jpg online']
  },
  'jpg-to-png': {
    title: 'Convert JPG to PNG - Free Online JPEG to PNG Converter',
    description: 'Convert JPG images to PNG format instantly. Free online JPEG to PNG converter. No uploads, no registration required.',
    keywords: 'jpg to png, jpeg to png, jpg converter, convert jpg to png, jpg to png online, free jpg converter, jpg to png converter',
    searchTerms: ['jpg to png', 'jpeg to png converter', 'convert jpg to png', 'jpg to png online']
  },
  'image-compressor': {
    title: 'Image Compressor - Free Online Image Compression Tool',
    description: 'Compress images to reduce file size. Free online image compression tool. No uploads, no registration required.',
    keywords: 'image compressor, compress images, image compression, reduce image size, free image compressor, online image compression',
    searchTerms: ['image compressor', 'compress images', 'image compression tool', 'reduce image size']
  },
  'image-cropper': {
    title: 'Image Cropper - Free Online Image Cropping Tool',
    description: 'Crop images to custom dimensions. Free online image cropping tool. No uploads, no registration required.',
    keywords: 'image cropper, crop images, image cropping, crop photo, free image cropper, online image cropping',
    searchTerms: ['image cropper', 'crop images', 'image cropping tool', 'crop photo online']
  },
  'image-to-base64': {
    title: 'Convert Image to Base64 - Free Online Image to Base64 Tool',
    description: 'Convert images to Base64 encoded strings. Free online image to Base64 converter. No uploads, no registration required.',
    keywords: 'image to base64, convert image to base64, base64 converter, image base64, free base64 converter',
    searchTerms: ['image to base64', 'convert image to base64', 'base64 converter', 'image base64']
  },
  'base64-to-image': {
    title: 'Convert Base64 to Image - Free Online Base64 to Image Tool',
    description: 'Convert Base64 strings back to images. Free online Base64 to image converter. No uploads, no registration required.',
    keywords: 'base64 to image, convert base64 to image, base64 decoder, base64 image converter, free base64 decoder',
    searchTerms: ['base64 to image', 'convert base64 to image', 'base64 decoder', 'base64 image converter']
  },
  'image-color-inverter': {
    title: 'Image Color Inverter - Free Online Color Inversion Tool',
    description: 'Invert colors in images. Free online image color inversion tool. No uploads, no registration required.',
    keywords: 'image color inverter, invert image colors, color inversion, negative image, free color inverter',
    searchTerms: ['image color inverter', 'invert image colors', 'color inversion tool', 'negative image']
  },

  // PDF Tools
  'pdf-merger': {
    title: 'PDF Merger - Free Online PDF Merge Tool',
    description: 'Merge multiple PDF files into one. Free online PDF merger. No uploads, no registration required.',
    keywords: 'pdf merger, merge pdf, combine pdf, pdf merge tool, free pdf merger, online pdf merger',
    searchTerms: ['pdf merger', 'merge pdf', 'combine pdf files', 'pdf merge tool']
  },
  'jpg-to-pdf': {
    title: 'Convert JPG to PDF - Free Online JPEG to PDF Converter',
    description: 'Convert JPG images to PDF format. Free online JPEG to PDF converter. No uploads, no registration required.',
    keywords: 'jpg to pdf, jpeg to pdf, convert jpg to pdf, image to pdf, free jpg to pdf converter',
    searchTerms: ['jpg to pdf', 'jpeg to pdf converter', 'convert jpg to pdf', 'image to pdf']
  },
  'pdf-to-jpg': {
    title: 'Convert PDF to JPG - Free Online PDF to Image Converter',
    description: 'Convert PDF pages to JPG images. Free online PDF to image converter. No uploads, no registration required.',
    keywords: 'pdf to jpg, pdf to jpeg, pdf to image, convert pdf to jpg, free pdf to image converter',
    searchTerms: ['pdf to jpg', 'pdf to image converter', 'convert pdf to jpg', 'pdf to jpeg']
  },
  'pdf-metadata': {
    title: 'PDF Metadata Viewer - Free Online PDF Info Tool',
    description: 'View and edit PDF metadata. Free online PDF information tool. No uploads, no registration required.',
    keywords: 'pdf metadata, pdf info, pdf properties, pdf metadata viewer, free pdf info tool',
    searchTerms: ['pdf metadata', 'pdf info', 'pdf properties', 'pdf metadata viewer']
  },
  'txt-to-pdf': {
    title: 'Convert TXT to PDF - Free Online Text to PDF Converter',
    description: 'Convert text files to PDF format. Free online TXT to PDF converter. No uploads, no registration required.',
    keywords: 'txt to pdf, text to pdf, convert txt to pdf, free txt to pdf converter',
    searchTerms: ['txt to pdf', 'text to pdf converter', 'convert txt to pdf', 'text to pdf']
  },

  // Text Tools
  'text-analyzer': {
    title: 'Text Analyzer - Free Online Text Analysis Tool',
    description: 'Analyze text for word count, character count, and more. Free online text analysis tool. No uploads, no registration required.',
    keywords: 'text analyzer, text analysis, word counter, character counter, free text analyzer',
    searchTerms: ['text analyzer', 'text analysis tool', 'word counter', 'character counter']
  },
  'bionic-reading': {
    title: 'Bionic Reading Converter - Free Online Bionic Reading Tool',
    description: 'Convert text to bionic reading format. Free online bionic reading converter. No uploads, no registration required.',
    keywords: 'bionic reading, bionic reading converter, speed reading, free bionic reading tool',
    searchTerms: ['bionic reading', 'bionic reading converter', 'speed reading tool', 'bionic reading format']
  },
  'text-capitalizer': {
    title: 'Text Capitalizer - Free Online Text Case Converter',
    description: 'Convert text case to title case, sentence case, and more. Free online text capitalizer. No uploads, no registration required.',
    keywords: 'text capitalizer, text case converter, title case, sentence case, free text capitalizer',
    searchTerms: ['text capitalizer', 'text case converter', 'title case', 'sentence case']
  },
  'uppercase-converter': {
    title: 'Convert Text to Uppercase - Free Online Uppercase Tool',
    description: 'Convert text to uppercase. Free online uppercase converter. No uploads, no registration required.',
    keywords: 'uppercase converter, text to uppercase, convert to uppercase, free uppercase converter',
    searchTerms: ['uppercase converter', 'text to uppercase', 'convert to uppercase', 'uppercase tool']
  },
  'lowercase-converter': {
    title: 'Convert Text to Lowercase - Free Online Lowercase Tool',
    description: 'Convert text to lowercase. Free online lowercase converter. No uploads, no registration required.',
    keywords: 'lowercase converter, text to lowercase, convert to lowercase, free lowercase converter',
    searchTerms: ['lowercase converter', 'text to lowercase', 'convert to lowercase', 'lowercase tool']
  },
  'camelcase-converter': {
    title: 'Convert Text to CamelCase - Free Online CamelCase Tool',
    description: 'Convert text to camelCase format. Free online camelCase converter. No uploads, no registration required.',
    keywords: 'camelcase converter, text to camelcase, convert to camelcase, free camelcase converter',
    searchTerms: ['camelcase converter', 'text to camelcase', 'convert to camelcase', 'camelcase tool']
  },
  'duplicate-remover': {
    title: 'Duplicate Line Remover - Free Online Duplicate Text Tool',
    description: 'Remove duplicate lines from text. Free online duplicate line remover. No uploads, no registration required.',
    keywords: 'duplicate line remover, remove duplicates, duplicate text remover, free duplicate remover',
    searchTerms: ['duplicate line remover', 'remove duplicates', 'duplicate text remover', 'remove duplicate lines']
  },
  'text-sorter': {
    title: 'Text Sorter - Free Online Text Sorting Tool',
    description: 'Sort text lines alphabetically. Free online text sorter. No uploads, no registration required.',
    keywords: 'text sorter, sort text, alphabetically sort, free text sorter, online text sorting',
    searchTerms: ['text sorter', 'sort text', 'alphabetically sort', 'text sorting tool']
  },

  // Encryption Tools
  'base64-encoder': {
    title: 'Base64 Encoder - Free Online Base64 Encoding Tool',
    description: 'Encode text to Base64 format. Free online Base64 encoder. No uploads, no registration required.',
    keywords: 'base64 encoder, encode to base64, text to base64, free base64 encoder',
    searchTerms: ['base64 encoder', 'encode to base64', 'text to base64', 'base64 encoding tool']
  },
  'md5-hash': {
    title: 'MD5 Hash Generator - Free Online MD5 Hash Tool',
    description: 'Generate MD5 hash from text. Free online MD5 hash generator. No uploads, no registration required.',
    keywords: 'md5 hash, md5 generator, md5 hash generator, free md5 hash tool',
    searchTerms: ['md5 hash', 'md5 generator', 'md5 hash generator', 'md5 hash tool']
  },
  'sha1-hash': {
    title: 'SHA1 Hash Generator - Free Online SHA1 Hash Tool',
    description: 'Generate SHA1 hash from text. Free online SHA1 hash generator. No uploads, no registration required.',
    keywords: 'sha1 hash, sha1 generator, sha1 hash generator, free sha1 hash tool',
    searchTerms: ['sha1 hash', 'sha1 generator', 'sha1 hash generator', 'sha1 hash tool']
  },
  'sha256-hash': {
    title: 'SHA256 Hash Generator - Free Online SHA256 Hash Tool',
    description: 'Generate SHA256 hash from text. Free online SHA256 hash generator. No uploads, no registration required.',
    keywords: 'sha256 hash, sha256 generator, sha256 hash generator, free sha256 hash tool',
    searchTerms: ['sha256 hash', 'sha256 generator', 'sha256 hash generator', 'sha256 hash tool']
  },
  'sha512-hash': {
    title: 'SHA512 Hash Generator - Free Online SHA512 Hash Tool',
    description: 'Generate SHA512 hash from text. Free online SHA512 hash generator. No uploads, no registration required.',
    keywords: 'sha512 hash, sha512 generator, sha512 hash generator, free sha512 hash tool',
    searchTerms: ['sha512 hash', 'sha512 generator', 'sha512 hash generator', 'sha512 hash tool']
  },
  'url-encoder': {
    title: 'URL Encoder - Free Online URL Encoding Tool',
    description: 'Encode URLs for web use. Free online URL encoder. No uploads, no registration required.',
    keywords: 'url encoder, encode url, url encoding, free url encoder, online url encoding',
    searchTerms: ['url encoder', 'encode url', 'url encoding', 'url encoding tool']
  },
  'html-encoder': {
    title: 'HTML Encoder - Free Online HTML Encoding Tool',
    description: 'Encode HTML entities. Free online HTML encoder. No uploads, no registration required.',
    keywords: 'html encoder, encode html, html encoding, free html encoder, online html encoding',
    searchTerms: ['html encoder', 'encode html', 'html encoding', 'html encoding tool']
  },

  // Developer Tools
  'csv-json-converter': {
    title: 'Convert CSV to JSON - Free Online CSV JSON Converter',
    description: 'Convert CSV to JSON format. Free online CSV to JSON converter. No uploads, no registration required.',
    keywords: 'csv to json, csv json converter, convert csv to json, free csv to json converter',
    searchTerms: ['csv to json', 'csv json converter', 'convert csv to json', 'csv to json converter']
  },
  'xml-formatter': {
    title: 'XML Formatter - Free Online XML Beautifier Tool',
    description: 'Format and beautify XML code. Free online XML formatter. No uploads, no registration required.',
    keywords: 'xml formatter, xml beautifier, format xml, free xml formatter, online xml formatting',
    searchTerms: ['xml formatter', 'xml beautifier', 'format xml', 'xml formatting tool']
  },
  'markdown-to-html': {
    title: 'Convert Markdown to HTML - Free Online Markdown Converter',
    description: 'Convert Markdown to HTML. Free online Markdown to HTML converter. No uploads, no registration required.',
    keywords: 'markdown to html, markdown converter, convert markdown to html, free markdown converter',
    searchTerms: ['markdown to html', 'markdown converter', 'convert markdown to html', 'markdown to html converter']
  },
  'markdown-preview': {
    title: 'Markdown Preview - Free Online Markdown Editor',
    description: 'Live Markdown preview with real-time rendering. Free online Markdown editor. No uploads, no registration required.',
    keywords: 'markdown preview, markdown editor, live markdown, free markdown editor, online markdown preview',
    searchTerms: ['markdown preview', 'markdown editor', 'live markdown', 'markdown preview tool']
  },
  'ip-to-binary': {
    title: 'Convert IP to Binary - Free Online IP Binary Converter',
    description: 'Convert IP addresses to binary format. Free online IP to binary converter. No uploads, no registration required.',
    keywords: 'ip to binary, ip binary converter, convert ip to binary, free ip to binary converter',
    searchTerms: ['ip to binary', 'ip binary converter', 'convert ip to binary', 'ip to binary converter']
  },
  'ascii-converter': {
    title: 'Convert Text to ASCII - Free Online ASCII Converter',
    description: 'Convert text to ASCII codes. Free online ASCII converter. No uploads, no registration required.',
    keywords: 'ascii converter, text to ascii, ascii codes, free ascii converter, online ascii conversion',
    searchTerms: ['ascii converter', 'text to ascii', 'ascii codes', 'ascii conversion tool']
  },
  'binary-text-converter': {
    title: 'Convert Text to Binary - Free Online Binary Text Converter',
    description: 'Convert text to binary representation. Free online text to binary converter. No uploads, no registration required.',
    keywords: 'text to binary, binary converter, convert text to binary, free binary converter',
    searchTerms: ['text to binary', 'binary converter', 'convert text to binary', 'text to binary converter']
  },

  // Converter Tools
  'numbers-to-words': {
    title: 'Convert Numbers to Words - Free Online Number to Text Tool',
    description: 'Convert numbers to written words. Free online number to words converter. No uploads, no registration required.',
    keywords: 'numbers to words, number to text, convert numbers to words, free number to words converter',
    searchTerms: ['numbers to words', 'number to text converter', 'convert numbers to words', 'number to words converter']
  },
  'number-base-converter': {
    title: 'Number Base Converter - Free Online Base Conversion Tool',
    description: 'Convert between binary, decimal, and hexadecimal. Free online number base converter. No uploads, no registration required.',
    keywords: 'number base converter, base conversion, binary decimal hex, free base converter, online base conversion',
    searchTerms: ['number base converter', 'base conversion', 'binary decimal hex', 'base conversion tool']
  },
  'timezone-converter': {
    title: 'Timezone Converter - Free Online Time Zone Tool',
    description: 'Convert time between different timezones. Free online timezone converter. No uploads, no registration required.',
    keywords: 'timezone converter, time zone converter, convert timezone, free timezone converter, online timezone conversion',
    searchTerms: ['timezone converter', 'time zone converter', 'convert timezone', 'timezone conversion tool']
  },
  'qr-generator': {
    title: 'QR Code Generator - Free Online QR Code Maker',
    description: 'Generate QR codes from text or URLs. Free online QR code generator. No uploads, no registration required.',
    keywords: 'qr code generator, qr code maker, generate qr code, free qr generator, online qr code generator',
    searchTerms: ['qr code generator', 'qr code maker', 'generate qr code', 'qr generator tool']
  }
}; 